import * as React from "react";
import {observer, inject} from "mobx-react";
import {withRouter, Route, Link, Switch} from "react-router-dom";
import BasketOrderList from './BasketOrderList';
import {ToolbarDropdown, ToolbarSection} from "@components/Toolbar/ToolbarDropdown"



@inject("store")
@observer
class BasketOrderView extends React.Component {


    constructor(props) {
        super(props);

        this.addProductRef = element => {
            this.addProductSelect = element;

        };

    }


    render() {
        const {store} = this.props;
        const orderStore = store.order;


        const parentMatch = this.props.match;

        return (

            <ToolbarDropdown
                navigation={this.props.store.navigation}
                key={"order"} match={parentMatch} hideHeader={this.props.hideHeader ? this.props.hideHeader : false} header={this.props.store.navigation.dictionary.Cart}>
                <ToolbarSection>
                    <BasketOrderList order={orderStore.activeOrder} basketView={true}/>
                </ToolbarSection>
            </ToolbarDropdown>


        );
    }
}


export default withRouter(BasketOrderView);